import { authStore } from '@/services/auth/store';
import tracking from '@/utils/tracking-scripts';
import { useStore } from '@nanostores/react';
import { useEffect, useRef } from 'react';

/**
 * Track users on injected scripts as soon as they are authenticated
 * (as opposed to waiting for a user to navigate to an authenticated URL).
 */
export function useTrackingScriptsInjection() {
  const { account, user } = useStore(authStore);
  const hasInjectedScripts = useRef<boolean>(false);

  useEffect(() => {
    if (account !== null && user !== null && !hasInjectedScripts.current) {
      // We only ever want to inject once.
      hasInjectedScripts.current = true;
      tracking.load({ authenticated: true, account, user });
    }
  }, [account, user]);
}
